import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/(internal)/site/[subdomain]/page.tsx");
